import React, { FC } from "react";
import classNames from "classnames/dedupe";
import { TPrice } from "./Price";

const SportLoversPrice: FC<TPrice> = ({
  classes,
  price,
  currency = "€",
  currencyPlace = "front",
}) => {
  return (
    <div
      className={classNames(
        "d-block product-price__sportLovers",
        classes?.root,
      )}
    >
      <span className="bg-color-white p-1">
        <span className="font-weight-bold">
          {currencyPlace === "front" ? `${currency} ` : null}
          {price}
          {currencyPlace === "back" ? ` ${currency}` : null}
        </span>
        <span className="ms-3 font-weight-regular">
          <span>SPORT</span>
          <span className="text-color-red">LOVERS</span>
        </span>
      </span>
      <br />
      <span className="text-color-white font-weight-regular">
        Exclusive for SportLover
      </span>
    </div>
  );
};

export default SportLoversPrice;
